import { AuditTimeline } from '../../components/AuditTimeline';
import { useHistory } from '../../components/use-history';

/** The trailer's whole history: field edits and status changes are all audited against `entityType: 'trailer'`. */
export function TrailerHistoryTab({ trailerId }: { trailerId: string }) {
  const state = useHistory('trailer', trailerId, true);
  return <AuditTimeline state={state} />;
}
